<template>
  <v-tooltip v-if="ready" :text="_tooltip" :disabled="_tooltip === ''" location="top" size="x-small">
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        density="compact"
        :color="_color"
        :type="_type"
        :disabled="_disabled"
        @click="_click(value)"
        :class="_buttonClass"
        variant="text"
      >
        <v-icon v-if="icon != null" :icon="icon" :class="_iconClass" :size="_size" />
        <span v-else>{{ label }}</span>
      </v-btn>
    </template>
  </v-tooltip>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    color: String,
    disabled: Boolean,
    buttonClass: String,
    iconClass: String,
    click: Function,
    type: String,
    label: String,
    icon: String,
    size: String,
    tooltip: String,
    value: typeof Number || typeof String || typeof Boolean || typeof Array || typeof Object
  }
})
export default class Button extends Vue {
  color?: string
  disabled?: boolean
  buttonClass?: string
  iconClass?: string
  click!: Function
  type?: string
  label?: string
  icon?: string
  size?: string
  tooltip?: string
  ready: boolean = false
  value?: number
  // show = true

  mounted() {
    this.ready = true
    // if (this.tooltip === '') {
    //   this.show = false
    // }
  }

  get _color(): string {
    return this.color != null ? this.color : ''
  }
  get _disabled(): boolean {
    return this.disabled != null ? this.disabled : false
  }
  get _buttonClass(): string {
    return this.buttonClass != null ? `${this.buttonClass} btn-base` : 'btn-base'
  }
  get _iconClass(): string {
    return this.iconClass != null ? this.iconClass : ''
  }
  get _type(): string {
    return this.type != null ? this.type : ''
  }
  get _label(): string {
    return this.label != null ? this.label : ''
  }
  get _size(): string {
    return this.size != null ? this.size : ''
  }
  get _tooltip(): string {
    if (this.tooltip != null) {
      return this.tooltip
    }
    if (this.label != null) {
      return this.label
    }
    // if (this.icon != null) {
    //   return this.icon.replace('mdi-', '').replace('-', ' ')
    // }
    return ''
  }
  get _click(): Function {
    if (this.click != null) {
      return this.click
    }
    return () => {}
  }
}
</script>
<style scoped lang="scss">
  .v-btn.btn-base {
    min-width: 32px;
  }
  .v-tooltip :deep(.v-overlay__content) {
    // background-color: #a6fbf697 !important;
    font-size: 12px !important;
    font-weight: bold !important;
  }
</style>